// extracted by mini-css-extract-plugin
module.exports = {"InfoValue":"RealestateInfoTile_InfoValue__3Qm9K","InfoText":"RealestateInfoTile_InfoText__rcNBz"};